import { render, staticRenderFns } from "./HomeTag.vue?vue&type=template&id=8a61b838&"
import script from "./HomeTag.vue?vue&type=script&lang=js&"
export * from "./HomeTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HomeTag.vue"
export default component.exports